import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { CenteredFlexColumn, FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const { carbon, blue } = colorsPalettes;

import { ROW_HEIGHT } from "../../consts";

export const AutocompleteTopicsListItemWrapper = styled(CenteredFlexColumn)<{ isActive: boolean }>`
    align-items: center;
    width: 100%;
    height: ${ROW_HEIGHT};
    box-sizing: border-box;
    padding: 12px 16px;
    cursor: pointer;
    transition: background-color 0.2s ease-out;
    background-color: ${({ isActive }) => (isActive ? carbon[25] : carbon[0])};

    &:hover {
        background-color: ${carbon[25]};
    }
`;

export const ContentContainer = styled(FlexColumn)<{ isActive?: boolean }>`
    width: 100%;
    align-items: start;
    justify-content: space-around;
    box-sizing: border-box;
    gap: 4px;
`;

export const TopicName = styled.div`
    ${setFontVariant("input2", carbon[500])};
    text-transform: capitalize;
`;

const StyledTopicIcon = styled(SWReactIcons)`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
`;

export const Breadcrumbs = styled.div`
    ${setFontVariant("listItem3", carbon[300])};
    text-transform: capitalize;
`;

export const HighlightedText = styled.span`
    font-weight: 700;
`;
